var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconXiaomiAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6900;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.005,47.75H16.995c-9.248,0-16.745-7.497-16.745-16.745V16.995C0.25,7.747,7.747,0.25,16.995,0.25h14.009 c9.248,0,16.745,7.497,16.745,16.745v14.009C47.75,40.253,40.253,47.75,31.005,47.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.717,
    y: 14.848,
    className: "st1",
    width: 4.519,
    height: 18.471
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.173,20.261v13.065h-4.507V21.495c0-0.046,0.03-0.244,0-0.487c-0.046-0.35-0.198-0.822-0.594-1.249 c-0.579-0.609-1.31-0.685-1.614-0.685h-9.273v14.253H9.662V14.825h14.816c0.259,0,0.685,0.015,1.188,0.122 c0.792,0.152,1.797,0.518,2.695,1.34c0.944,0.868,1.416,1.888,1.629,2.787C30.112,19.515,30.158,19.926,30.173,20.261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.604,
    y: 21.949,
    className: "st1",
    width: 4.519,
    height: 11.371
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXiaomiAppStore);
export default __webpack_public_path__ + "static/media/icon_xiaomi_app_store.729bc39153eff33a1abdf0ed632f94df.svg";
export { ForwardRef as ReactComponent };